import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const fetchBannersData = (token, page) => async (dispatch) => {
  dispatch({ type: "FETCH_BANNER_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getAllBanners?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: "FETCH_BANNER_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_BANNER_FAILURE",
      payload: error.message,
    });
  }
};
